import React, { useState } from 'react';
import { connect  } from 'react-redux';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { State } from 'store/state';
import { CleanButton } from 'ds/components/button';
import { MobileMapSwitcher } from 'components/mobile-map-switcher/MobileMapSwitcher';
import { createPortal } from 'utils/universalPortal';
import { SEARCH_BOTTOM_ROOT } from 'consts/rootNodes';
import { NumberIcon } from 'components/filters/styled/FilterSummaryButton';
import FiltersModal from 'screens/DeveloperPage/components/filters';
import { developerFiltersCountSelector } from 'screens/DeveloperPage/selectors';

export const Root = styled.div<{ hasContact?: boolean; }>`
  position: fixed;
  bottom: ${({ hasContact }) => hasContact ? 82 : 40}px;
  left: 0;
  right: 0;
  z-index: 12;
`;


interface MapListToggleProps {
  count: number;
  showMap: boolean;
  setShowMap: (show: boolean) => void;
  hasPaddingBottom: boolean;
}

const MapListToggle: React.FC<MapListToggleProps> = (props) => {
  const { count, showMap, setShowMap, hasPaddingBottom } = props;
  const [ isFilterModalOpen, setIsFilterModalOpen ] = useState();
  const { t } = useLocale();
  const toggleModal = () => setIsFilterModalOpen(!isFilterModalOpen);
  const toggleMap = () => setShowMap(!showMap);
  return (
    <div>
      {isFilterModalOpen ? <FiltersModal isModal closeModal={toggleModal} /> : null}
      {createPortal(
        <Root hasContact={hasPaddingBottom}>
          <MobileMapSwitcher toggleMap={toggleMap} isMobileMapViewActive={showMap}>
            <CleanButton onClick={toggleModal}>
              {count ? (<NumberIcon num={count} />) : null}
              {t('developerPage.navigation.filter', { count: 0 })}
            </CleanButton>
          </MobileMapSwitcher>
        </Root>
      , SEARCH_BOTTOM_ROOT)}
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  count: developerFiltersCountSelector(state),
});

export default connect(mapStateToProps)(MapListToggle);
